/*
 * WARNING: THIS IS AN AUTOGENERATED-FILE. DO NOT MANUALLY EDIT THIS FILE.
 *
 * MODIFY FLAGS DATA IN lib/gating.rb AND RUN `bundle exec bin/generate-ts-constants`
 * TO REGENERATE THIS FILE.
 */

export enum Feature {
  ProdEnvironmentIndicator = "ProdEnvironmentIndicator",
  DeveloperMode = "DeveloperMode",
  ColumnHooks = "ColumnHooks",
  EventHooks = "EventHooks",
  AllowRemoveLogo = "AllowRemoveLogo",
  AdvancedBranding = "AdvancedBranding",
  I18N = "I18N",
  HideImportActivityPreview = "HideImportActivityPreview",
  CustomColumns = "CustomColumns",
  ValidationWebhooks = "ValidationWebhooks",
  Headless = "Headless",
  HeadlessValidation = "HeadlessValidation",
  DynamicTemplates = "DynamicTemplates",
  AuditLogs = "AuditLogs",
  ExtendedMetadataWebhookTimeout = "ExtendedMetadataWebhookTimeout",
  AdvancedMappings = "AdvancedMappings",
  CustomEnvironments = "CustomEnvironments",
  CodeHooksV1 = "CodeHooksV1",
  Customizations = "Customizations",
  Integrations = "Integrations",
  TestMaskDataHighlighting = "TestMaskDataHighlighting",
  InAppBilling = "InAppBilling",
  ValidationWebhooksUnmappedCols = "ValidationWebhooksUnmappedCols",
  TemplateColumnsOrder = "TemplateColumnsOrder",
  LockColumns = "LockColumns",
  CsAnalystImport = "CsAnalystImport",
  UserRoleManagement = "UserRoleManagement",
  FileFeeds = "FileFeeds",
  SelfServeTrial = "SelfServeTrial",
  ServerReachabilityPing = "ServerReachabilityPing",
  DebugTemplatesEndpointLag = "DebugTemplatesEndpointLag",
  EmbeddedPipelineBuilder = "EmbeddedPipelineBuilder",
  FileFeedInternalS3 = "FileFeedInternalS3",
  DisableDateAutoFormatting = "DisableDateAutoFormatting",
  SuggestedTransforms = "SuggestedTransforms",
  PipelineStepRunPostMappingHooks = "PipelineStepRunPostMappingHooks",
  MalwareFileScan = "MalwareFileScan",
  ShowApiTemplateHooks = "ShowApiTemplateHooks",
  GraphqlApi = "GraphqlApi",
  BulkTargetAttributeUpdate = "BulkTargetAttributeUpdate",
  TemplateJsonHooksField = "TemplateJsonHooksField",
  FileFeedsSavedMappings = "FileFeedsSavedMappings",
  SftpAccountSshKeyNewlineReplacement = "SftpAccountSshKeyNewlineReplacement",
  MultiUseSftpPath = "MultiUseSftpPath",
  FileFeedIngestionHooks = "FileFeedIngestionHooks",
  UploadAllowDatExtension = "UploadAllowDatExtension",
  RowUniquenessValidation = "RowUniquenessValidation",
  PosthogDisabled = "PosthogDisabled",
  FileFeedExcelSheetSelection = "FileFeedExcelSheetSelection",
  FileFeedVerification = "FileFeedVerification",
  WorkspacesV1 = "WorkspacesV1",
  Workflows = "Workflows",
  RelationalValidations = "RelationalValidations",
  LegacyForbiddenErrorCode = "LegacyForbiddenErrorCode",
  FileFeedWarningsTriggerPartialImport = "FileFeedWarningsTriggerPartialImport",
  DebugEntities = "DebugEntities",
  LegacyValidationHooksAuthType = "LegacyValidationHooksAuthType",
  AiFeatures = "AiFeatures",
  ParallelValidationCodeHooks = "ParallelValidationCodeHooks",
  WorkflowsPdfExtraction = "WorkflowsPdfExtraction",
  WorkspacesExternalCollaborators = "WorkspacesExternalCollaborators",
  WorkflowsAiClassifyValues = "WorkflowsAiClassifyValues",
  EmailLoginWithSso = "EmailLoginWithSso",
  DisableEmailLogin = "DisableEmailLogin",
  FixWithAi = "FixWithAi",
  FileFeedEnforceSavedMappingColumnPresence = "FileFeedEnforceSavedMappingColumnPresence",
  WorkflowsDemo = "WorkflowsDemo",
  InternalApiAuthHeaderAccess = "InternalApiAuthHeaderAccess",
  ExternalAPI = "ExternalAPI",
  WorkflowsCsvAgent = "WorkflowsCsvAgent",
  A11yUserwayWidget = "A11yUserwayWidget",
  WorkflowsNoHeaderDetection = "WorkflowsNoHeaderDetection",
  WorkflowsKeepBlankRows = "WorkflowsKeepBlankRows",
  OrgUsageRecord = "OrgUsageRecord",
  WorkflowsTrackCredits = "WorkflowsTrackCredits",
  EnableGetTemplatesExtApi = "EnableGetTemplatesExtApi",
  ImporterExportParquet = "ImporterExportParquet",
  ImporterEventSnapshots = "ImporterEventSnapshots",
  AiServiceCodeGeneration = "AiServiceCodeGeneration",
  PauseScheduledDeleteEmbeds = "PauseScheduledDeleteEmbeds",
  WorkflowsSplitList = "WorkflowsSplitList",
  AiSettings = "AiSettings",
  LargeFileImportTimeout = "LargeFileImportTimeout",
  AvailableLlmProviders = "AvailableLlmProviders",
  AiCodeGeneration = "AiCodeGeneration",
  AiMapping = "AiMapping",
  UsageAndBilling = "UsageAndBilling",
  UseMultipartUpload = "UseMultipartUpload",
}

export enum PermanentFeature {
  Importer = "Importer",
  CodeHooksApi = "CodeHooksApi",
  IncreasedCodeHookTimeout = "IncreasedCodeHookTimeout",
}
